import i18next from 'i18next';

i18next.addResources('es', 'Title', {
  title: 'Gobierno de la Provincia de Salta'
});
